import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";

export const EstatusIcon = ({ estatus }) => {
  if (estatus === true)
    return <CheckCircleOutlined style={{ color: "#04c73b", fontSize: 20 }} />;
  return <CloseCircleOutlined style={{ color: "#ca2228", fontSize: 20 }} />;
};
